import React, { useState } from 'react';
import { Users, UserPlus, Shield, UserCheck } from 'lucide-react';
import { MembersTable } from './MembersTable';
import { AddMemberForm } from './AddMemberForm';

interface TeamManagementPageProps {
  projectId: string;
  projectName?: string;
  onClose?: () => void;
}

export const TeamManagementPage: React.FC<TeamManagementPageProps> = ({ projectId, projectName }) => {
  const [activeTab, setActiveTab] = useState<'members' | 'add'>('members');

  return (
    <div className="space-y-6 animate-[fadeIn_0.3s_ease-out]">
      {/* Top Banner / Header */}
      <div className="rounded-3xl border border-slate-200/80 bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-950 p-6 text-white shadow-xl">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-1 text-xs font-bold uppercase tracking-wider text-blue-300 backdrop-blur-md">
              <Users size={14} />
              MANPRO Team Management
            </div>
            <h2 className="mt-3 text-2xl sm:text-3xl font-extrabold tracking-tight text-white">
              Kelola Tim Proyek
            </h2>
            <p className="mt-1 max-w-2xl text-sm leading-relaxed text-slate-300">
              Atur hak akses anggota, kirim undangan manual, serta tambahkan tim dari marketplace atau organisasi mitra secara langsung.
            </p>
          </div>
          
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2 rounded-2xl bg-white/10 p-3 backdrop-blur-md border border-white/10 text-xs text-slate-200">
              <Shield size={18} className="text-emerald-400" />
              <div>
                <div className="font-semibold text-white">Canonical Role System</div>
                <div className="text-slate-400">Owner, Manager, Contractor, Architect, Finance, Viewer</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Tabs */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-2">
        <div className="inline-flex p-1 bg-slate-100/80 backdrop-blur-md rounded-2xl border border-slate-200/80 shadow-inner w-full sm:w-auto">
          <button
            onClick={() => setActiveTab('members')}
            className={`flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 flex-1 sm:flex-initial ${
              activeTab === 'members'
                ? 'bg-white text-slate-900 shadow-md shadow-slate-200/50 ring-1 ring-slate-200/80'
                : 'text-slate-500 hover:text-slate-800 hover:bg-white/50'
            }`}
          >
            <UserCheck size={16} />
            <span>Anggota Saat Ini</span>
          </button>

          <button
            onClick={() => setActiveTab('add')}
            className={`flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-semibold rounded-xl transition-all duration-200 flex-1 sm:flex-initial ${
              activeTab === 'add'
                ? 'bg-white text-slate-900 shadow-md shadow-slate-200/50 ring-1 ring-slate-200/80'
                : 'text-slate-500 hover:text-slate-800 hover:bg-white/50'
            }`}
          >
            <UserPlus size={16} />
            <span>Tambah Anggota</span>
          </button>
        </div>
      </div>

      {/* Tab Content Container */}
      <div className="rounded-3xl border border-slate-200/80 bg-white/95 p-6 shadow-sm backdrop-blur">
        {activeTab === 'members' ? (
          <MembersTable projectId={projectId} onNavigateToAdd={() => setActiveTab('add')} />
        ) : (
          <AddMemberForm projectId={projectId} projectName={projectName} onSuccess={() => setActiveTab('members')} />
        )}
      </div>
    </div>
  );
};
